export default {
    actionUndo: {
        message: "如果您点击错误，请点击下面的链接进行恢复。",
        undo: "单击以撤消"
    }
}